<template>
  <div>
    <JoinWrapper>
      <section v-if="isEventOpen" class="event_wrap">
        <div class="head_txt">
          <h2>환영합니다!</h2>
          <span>회원가입이 완료되었습니다.</span>
        </div>
        <div class="bottom_txt">
          <span class="bene_txt">신규 가입 한정 혜택</span>
          <ul class="benfit_wrap">
            <li>
              <router-link :to="{ name: 'discount' }">
                <div class="topic">
                  신규 회원 대상 <span class="br">할인 쿠폰팩 증정</span>
                </div>
                <span class="bene_num">혜택 01</span>
                <div class="dis_coupon10">
                  <span>할인쿠폰</span>
                  <b>10%</b>
                </div>
                <div class="dis_coupon5">
                  <span>할인쿠폰</span>
                  <b>5%</b>
                </div>
                <span class="event_mnt">
                  할인쿠폰팩 증정 <br />
                  <!-- <span class="small_txt">(~9월 30일 까지)</span> -->
                </span>
                <span class="priod">기간 : 25년 4월 30일까지 사용 가능</span>
              </router-link>
            </li>
            <li class="bene2">
              <span class="bene_num mb">혜택 02</span>
              <div class="gift_img">
                <img
                  src="@/assets/images/login_join/gift_event.png"
                  alt="선물상자"
                />
              </div>
              <span class="event_mnt mt">
                매달 추첨 스타벅스 <br />
                아메리카노 증정! <br />
                <span class="small_txt">(※마케팅 수신 동의시)</span>
              </span>
            </li>
          </ul>
        </div>
        <div class="btn_wrap">
          <a href="/" class="box_btn">
            <span class="an_t">확인</span>
          </a>
        </div>
      </section>
      <div v-else class="member_complete_wrap">
        <div>
          <div class="ph_img">
            <figure>
              <img src="@/assets/images/login_join/finish.png" alt="완료" />
            </figure>
            <span>환영합니다!</span>
            <p class="complete_message">회원가입이 완료되었습니다.</p>
          </div>
          <div class="btn_wrap">
            <!-- <p class="guide_txt">{{ $t('views.auth.join.joinstep1.2285') }}</p> -->
            <a href="/" class="box_btn">
              <span class="an_t">확인</span>
            </a>
          </div>
        </div>
      </div>
    </JoinWrapper>
  </div>
</template>

<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
export default {
  name: 'JoinComplete',

  components: {
    JoinWrapper
  },
  data() {
    return {
      allowed: false
    }
  },
  computed: {
    isEventOpen() {
      const today = new Date()
      const startDate = new Date('2025-02-25T10:30:00') // 이벤트 시작 날짜
      const endDate = new Date('2025-04-30T23:59:59') // 이벤트 종료 날짜
      return today >= startDate && today <= endDate
    }
  },
  beforeRouteEnter(to, from, next) {
    // 이전 페이지가 join_step4가 아닌 경우 404로 리디렉션
    if (!from.name || from.name !== 'join_step4') {
      next({ name: '404' })
    } else {
      next((vm) => {
        vm.allowed = true // 페이지 접근을 허용
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.event_wrap {
  padding: 0 15px;
}
.ph_img {
  text-align: center;
  figure {
    margin: 0;
    > img {
      width: 320px;
      height: 200px;
    }
  }
  span {
    margin-top: 30px;
    margin-bottom: 30px;
    display: block;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #333333;
  }
  .complete_message {
    font-size: 15px;
    color: #777777;
    margin-bottom: 174px;
  }
}
.member_complete_wrap {
  margin-top: 160px;
}
.event_wrap {
  .head_txt {
    position: relative;
    margin-bottom: 60px;
    padding-top: 35px;
    text-align: center;
    &::before {
      content: '';
      position: absolute;
      top: -25px;
      left: 0;
      background-size: contain;
      width: 190px;
      height: 190px;
      background: url('../../../assets/images/login_join/left_pop.png')
        no-repeat;
    }
    &::after {
      content: '';
      position: absolute;
      top: -25px;
      right: 0;
      background-size: contain;
      width: 190px;
      height: 190px;
      background: url('../../../assets/images/login_join/right_pop.png')
        no-repeat;
    }
    h2 {
      margin-bottom: 15px;
      letter-spacing: 0.5px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 31px;
      color: #000000;
    }
    span {
      letter-spacing: 0.2px;
      font-weight: 600;
      font-size: 22px;
      color: #898989;
    }
  }
  .bottom_txt {
    text-align: center;
    .bene_txt {
      display: inline-block;
      margin-bottom: 25px;
      padding: 20px 30px;
      letter-spacing: 1px;
      border-radius: 30px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 26px;
      background-color: #008df3;
      color: #ffffff;
    }
    .benfit_wrap {
      display: flex;
      justify-content: space-between;
      gap: 20px;
      margin-bottom: 18px;
      li {
        flex: 1;
        background-color: #f0f5fa;
        border-radius: 10px;
        &.bene2 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        a {
          display: block;
          padding: 15px 40px 25px;
        }
        .bene_num {
          display: inline-block;
          margin-bottom: 15px;
          padding: 12px 20px;
          background-color: #008df3;
          border-radius: 20px;
          font-weight: 600;
          font-size: 18px;
          color: #ffffff;
          &.mb {
            width: 100px;
            margin-bottom: 0;
          }
        }
        .topic {
          padding: 12px 20px;
          border-radius: 20px;
          font-weight: 600;
          font-family: 'pretendard-medium';
          font-size: 24px;
          letter-spacing: 1px;
          .br {
            display: block;
          }
        }
        .dis_coupon10,
        .dis_coupon5 {
          width: 215px;
          margin: 0 auto;
          padding: 15px 0;
          background-color: #232323;

          span {
            display: inline-block;
            border-bottom: 1px solid #f0f5fa;
            padding-bottom: 3px;
            letter-spacing: -0.03em;
            line-height: 19px;
            font-family: 'pretendard-light';
            font-weight: 600;
            font-size: 19px;
            color: #ffffff;
          }
          b {
            display: block;
            margin-top: 7px;
            font-family: 'pretendard-medium';
            font-weight: 600;
            font-size: 41px;
            line-height: 41px;
            letter-spacing: 2px;
            color: #ffffff;
          }
        }
        .dis_coupon10 {
          position: relative;
          margin-bottom: 10px;
          &::after {
            display: none;
            content: 'X3';
            position: absolute;
            right: -15px;
            bottom: -10px;
            width: 25px;
            height: 25px;
            padding: 10px;
            line-height: 25px;
            border-radius: 100%;
            font-family: 'pretendard-medium';
            font-size: 22px;
            background-color: #005b93;
            color: #ffffff;
          }
        }
        .priod {
          display: block;
          margin-top: 10px;
          font-family: 'pretendard-light';
          color: #545454;
        }
        .event_mnt {
          display: block;
          margin-top: 20px;
          line-height: 26px;
          font-family: 'pretendard-medium';
          font-weight: 600;
          font-size: 26px;
          color: #1f1f1f;
          &.mt {
            margin-top: 10px;
          }
          .small_txt {
            font-size: 22px;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .event_wrap {
    max-width: 500px;
    margin: 0 auto;
  }
  .event_wrap .bottom_txt .benfit_wrap {
    flex-direction: column;
  }
  .event_wrap .bottom_txt .benfit_wrap li.bene2 {
    padding: 25px 0;
  }
  .event_wrap .bottom_txt .benfit_wrap li .bene_num.mb {
    width: 85px;
  }
}
@media (max-width: 480px) {
  .event_wrap {
    .head_txt {
      margin-bottom: 35px;
      &::before {
        top: -20px;
        left: -50px;
        width: 160px;
        height: 160px;
      }
      &::after {
        top: -20px;
        right: -60px;
        width: 160px;
        height: 160px;
      }
      h2 {
        letter-spacing: -0.2px;
        margin-bottom: 10px;
        font-size: 28px;
      }
      span {
        font-size: 19px;
      }
    }
    .bottom_txt {
      .bene_txt {
        margin-bottom: 19px;
        padding: 17px 26px;
        font-size: 22px;
      }
      .benfit_wrap {
        flex-direction: column;
        align-items: center;
        li {
          width: 100%;
          padding: 10px 0 10px;
          a {
            padding: 0px 0px 10px;
          }
          .bene_num {
            padding: 9px 14px;
            letter-spacing: 1px;
            font-size: 14px;
          }
          .topic {
            span {
              display: block;
            }
          }
          .dis_coupon10,
          .dis_coupon5 {
            padding: 6px 0;
            span {
              line-height: 19px;
              font-size: 16px;
              letter-spacing: 0.5px;
            }
            b {
              font-size: 35px;
              line-height: 35px;
            }
          }
          .dis_coupon10::after {
            width: 18px;
            height: 18px;
            padding: 9px;
            line-height: 18px;
            font-size: 17px;
          }
          .priod {
            font-size: 14px;
          }
          .event_mnt {
            margin-top: 15px;
            line-height: 22px;
            font-size: 22px;
            &.mt {
              margin-top: 5px;
              line-height: 25px;
            }
            .small_txt {
              font-size: 17px;
            }
          }
          .gift_img {
            width: 165px;
            height: 155px;
            img {
              width: 100%;
              height: 100%;
              image-rendering: -webkit-optimize-contrast;
              transform: translateZ(0);
              backface-visibility: hidden;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 375px) {
  .member_complete_wrap {
    margin-top: 110px;
  }
  .ph_img {
    .complete_message {
      margin-bottom: 125px;
    }
  }
}
</style>
